/**
 * The bar right above a list, the same on every page:
 *   [Title · count] [search box]  ……  [extra actions] [Export]
 * Page-wide switches (company, Simple / More detail, views) never go here; they sit at the right of the tab row.
 */
import type { ReactNode } from "react";
import { t } from "../lib/i18n.tsx";

export function SearchField({ value, onChange, placeholder, onEnter }: { value: string; onChange: (v: string) => void; placeholder?: string; onEnter?: () => void }) {
  return (
    <label className="lsearch">
      <svg className="ico" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" />
      </svg>
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} onKeyDown={(e) => e.key === "Enter" && onEnter?.()} placeholder={placeholder ?? t("Filter parts")} aria-label={placeholder ?? t("Filter parts")} />
    </label>
  );
}

export function ExportButton({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) {
  return (
    <button type="button" className="btn hide-m" onClick={onClick} disabled={disabled}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        <path d="M12 4v11m0 0-4-4m4 4 4-4M5 19h14" />
      </svg>
      {t("Export")}
    </button>
  );
}

export function ListBar({
  title, search, onSearch, placeholder, children,
}: {
  title: ReactNode;
  search?: string;
  onSearch?: (v: string) => void;
  placeholder?: string;
  children?: ReactNode;
}) {
  return (
    <div className="listbar">
      <h3 className="list-title">{title}</h3>
      {onSearch && <SearchField value={search ?? ""} onChange={onSearch} placeholder={placeholder} />}
      <span className="spacer" />
      {children}
    </div>
  );
}
